(ns minorodata.components.data-views.panel
  (:require ["allotment" :refer [Allotment]]
            ["react-resize-detector" :refer [useResizeDetector]]
            ["react" :as react]
            [clojure.string]
            [lucide-react :refer [ChevronDown ChevronRight Info MoreHorizontal
                                  Play]]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.data-views.preview :refer [preview]]
            [minorodata.components.monaco.editor :as monaco.editor]
            [minorodata.data-views.model :refer [->data-views-page]]
            [mold-forms.core :as form-component]
            [mold-forms.model :refer [->form-model]]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.autocomplete :refer [autocomplete]]
            [ui.button :refer [button]]
            [ui.dialog :refer [dialog dialog-actions]]
            [ui.dropdown-menu :refer [dropdown-menu dropdown-menu-item
                                      dropdown-menu-sub]]
            [ui.fields :as fields]
            [ui.tooltip :as tooltip]
            [ui.typography :as typography]))

(defn show-share-modal []
  (dispatch [:data-views-page/update (->data-views-page {:share-data-view-modal-open? true})]))

(defn close-share-modal []
  (dispatch [:data-views-page/update (->data-views-page {:share-data-view-modal-open? false})]))

(defn show-delete-modal []
  (dispatch [:data-views-page/update (->data-views-page {:delete-data-view-modal-open? true})]))

(defn close-delete-modal []
  (dispatch [:data-views-page/update (->data-views-page {:delete-data-view-modal-open? false})]))

(defn show-save-as-modal []
  (dispatch [:data-views-page/update (->data-views-page {:save-as-data-view-modal-open? true})]))

(defn close-save-as-modal []
  (dispatch [:data-views-page/update (->data-views-page {:save-as-data-view-modal-open? false})]))

(defn allowed?
  [permissions]
  @(re-posh/subscribe [:users.subs/has-permissions? permissions]))

(defn share-data-view [data-view-id form]
  (let [form-data (form-component/model->fields form)
        user-ids (:users form-data)]
    (dispatch [:data-views.api/share-data-view {:user-ids user-ids :id data-view-id :on-success close-share-modal}])))

(defn update-editor [code]
  (dispatch [:data-views-page/update (->data-views-page {:editor-code code})]))

(defn users-dropdown [{:keys [value on-change]}]
  (let [users        @(re-posh/subscribe [:searchable-user/pull-many])
        user-options (->> users
                          (filter :searchable-user/active)
                          (mapv (fn [{:searchable-user/keys [id email]}]
                                  {:value id :text email})))]
    [autocomplete {:label     "Add users"
                   :values    (or value [])
                   :options   user-options
                   :on-change on-change
                   :format-value (fn [v]
                                   (some (fn [{:keys [value text]}]
                                           (when (= v value) text))
                                         user-options))}]))

(defn save-as-data-view-modal-render []
  (let [code         @(re-posh/subscribe [:data-views-page/prop :data-views-page/editor-code])
        open?        (boolean @(re-posh/subscribe [:data-views-page/prop :data-views-page/save-as-data-view-modal-open?]))
        on-close     (fn [opened?] (when (not opened?) (close-save-as-modal)))
        on-success   (fn [data-view]
                       (close-save-as-modal)
                       (dispatch [:app.events/navigate :data-view-details {:data-view-id (:data-view/data-view-id data-view)}]))
        on-submit    (fn [{:form-model/keys [fields]}]
                       (let [name (:form-field/value (first fields))]
                         (dispatch [:data-views.api/create-data-view {:params {:name name :command code}
                                                                      :on-success on-success}])))]
    [dialog {:open           open?
             :on-open-change on-close
             :title          "Save as new data view"
             :content
             [form-component/form
              (->form-model
               {:id            :share-data-view-form
                :track-changes true
                :on-submit     on-submit
                :fields        [{:name :name :value ""}]})
              (fn [fields errors on-submit]
                [:<>
                 [fields/input
                  {:field      (:name fields)
                   :errors     errors
                   :id         :name
                   :auto-focus true
                   :label      "Name"
                   :data-cy    "save-as-data-view-input"}]
                 [dialog-actions
                  [button {:on-click on-submit}
                   "Save"]]])]}]))

(defn share-data-view-modal-render []
  (let [_ (dispatch [:users.api/fetch-searchable-users])]
    (fn []
      (let [params       @(re-posh/subscribe [:app-route/prop :app-route/params])
            data-view-id (:data-view-id params)
            open?        (boolean @(re-posh/subscribe [:data-views-page/prop :data-views-page/share-data-view-modal-open?]))
            on-close     (fn [v] (when (false? v) (close-share-modal)))]
        [dialog {:open           open?
                 :on-open-change on-close
                 :root-props {:modal false}
                 :content-props {:modal false}
                 :title          "Share data view"
                 :description    "You can share a data view only with an existing user of your company’s Kleene account. If the user doesn’t have access to your company’s Kleene account please ask your admin to create their account."

                 :content
                 [:div {}
                  [form-component/form
                   (->form-model
                    {:id            :share-data-view-form
                     :track-changes true
                     :on-submit     (partial share-data-view data-view-id)
                     :fields        [{:name :users :value [] :process identity}]})
                   (fn [fields _ on-submit]
                     [:div {:class "mt-4"}
                      [:div {:class ""}
                       [users-dropdown {:value     (get-in fields [:users :value])
                                        :on-change (get-in fields [:users :action])}]]
                      [dialog-actions
                       [button {:disabled   (empty? (get-in fields [:users :value]))
                                :on-click   on-submit}
                        "Share"]]])]]}]))))

(defn delete-data-view-modal-render []
  (let [params       @(re-posh/subscribe [:app-route/prop :app-route/params])
        data-view-id (:data-view-id params)
        open?        (boolean @(re-posh/subscribe [:data-views-page/prop :data-views-page/delete-data-view-modal-open?]))
        on-delete    (fn []
                       (dispatch [:data-views.api/delete-data-view {:id data-view-id}])
                       (dispatch [:app.events/navigate :data-views])
                       (close-delete-modal))
        on-close     (fn [v] (when (false? v) (close-delete-modal)))]
    [dialog {:open open?
             :on-open-change on-close
             :title "Are you sure?"
             :description "There will be no way to recover it"
             :content [:div
                       [dialog-actions
                        [button {:data-cy :data-view-delete-cancel-btn
                                 :variant  :secondary
                                 :on-click close-delete-modal}
                         "Cancel"]
                        [button {:data-cy :data-view-delete-confirm-btn
                                 :variant  :error
                                 :on-click on-delete}
                         "Yes, delete this data view"]]]}]))

(defn select-prompt []
  [:div {:class "flex h-full w-full items-center justify-center"}
   [typography/h3 "Select a data view"]])

(defn data-view-preview-prompt [{:keys [data-view]}]
  (let [{:data-view/keys [data-view-id name]} data-view

        executing?       @(re-posh/subscribe [:mold-http/loading? :data-views.api/preview])
        preview          #(dispatch [:data-views.api/preview {:id data-view-id}])]
    [:div {:class "flex flex-col gap-2 h-full w-full items-center justify-center"}
     [typography/h2 name]

     [:div
      [button {:disabled executing?
               :loading  executing?
               :on-click preview
               :data-cy  "data-view-panel-preview"
               :icon     Play
               :size     :large}
       "Preview"]]]))

(defn download-fn [data-view statement-index file-type]
  (dispatch [:data-views.api/download {:data-view data-view
                                       :statement-index statement-index
                                       :file-type file-type}]))

(defn file-type-menu [{:keys [selected-index download]}]
  [:<>
   [dropdown-menu-item {:on-click #(download selected-index :csv)
                        :data-cy  "data-view-download-download-item"}
    "CSV"]
   [dropdown-menu-item {:on-click #(download selected-index :xls)
                        :data-cy  "data-view-download-download-item"}
    [:div
     "XLSX"
     [:p {:class "text-xs text-kleene-dark-05"}
      "1 million rows limit"]]]])

(defn statements-menu [{:keys  [data-views-count download]}]
  [:<>
   (for [i (range data-views-count)]
     ^{:key i}
     [dropdown-menu-sub {:content [file-type-menu {:selected-index i
                                                   :download       download}]}
      [:span {:class "flex items-center gap-2"} [:span (str "Statement " (inc i))] [:> ChevronRight {:size 16}]]])])

(defn download-button [{:keys [data data-view]}]
  (let [data-views-count     (count data)
        multiple-statements? (> data-views-count 1)

        downloading? @(re-posh/subscribe [:data-views-page/prop :data-views-page/downloading?])

        download (fn [idx filetype]
                   (download-fn data-view idx filetype))]
    [:<>
     [dropdown-menu {:content [:div
                               (if multiple-statements?
                                 [statements-menu {:data-views-count data-views-count
                                                   :download         download}]

                                 [file-type-menu {:selected-index 0
                                                  :download       download}])]}
      [:div
       [button {:size       :sm
                :variant    :secondary
                :data-cy    "data-view-header-download-menu-btn"
                :data-index 0
                :disabled   downloading?
                :loading    downloading?
                :icon-right ChevronDown}
        "Download"]]]]))

(defn more-menu []
  (let [menu-ref (reagent/atom nil)]
    (fn [{:keys [data-view]}]
      (let [can-delete? @(re-posh/subscribe [:data-views.subs/can-modify data-view])
            on-delete (fn []
                        (show-delete-modal)
                        (reset! menu-ref nil))]
        [:<>
         [dropdown-menu {:content [:div
                                   [dropdown-menu-item {:on-click on-delete
                                                        :data-cy  "data-view-delete-item"}
                                    [:div
                                     [:span {:class "text-kleene-text-error"}
                                      "Delete data view"]
                                     (when (not can-delete?)
                                       [:p {:class "text-kleene-dark-05 text-xs"}
                                        "You can't delete another user data views"])]]]}
          [:div
           [button {:size       :sm
                    :variant    :secondary
                    :data-index 0
                    :data-cy    "data-view-more-btn"
                    :icon       MoreHorizontal}]]]]))))

(defn preview-button [{:keys [data-view]}]
  (let [{:data-view/keys [data-view-id]} data-view

        executing? @(re-posh/subscribe [:mold-http/loading? :data-views.api/preview])
        preview    #(dispatch [:data-views.api/preview {:id data-view-id}])]
    [button {:size     :sm
             :disabled executing?
             :loading  executing?
             :on-click preview
             :icon     Play
             :data-cy  "data-view-header-preview-btn"}
     "Preview"]))

(defn toggle-sql-button []
  (let [show-editor?     @(re-posh/subscribe [:data-views-page/prop :data-views-page/show-editor])
        on-editor-toggle #(dispatch [:data-views-page/update (->data-views-page {:show-editor (not show-editor?)})])]
    (if show-editor?
      [button {:size     :sm
               :variant  :secondary
               :on-click on-editor-toggle
               :data-cy  "data-view-header-sql-hide-btn"}
       "Hide SQL"]
      [button {:size     :sm
               :variant  :secondary
               :on-click on-editor-toggle
               :data-cy  "data-view-header-sql-show-btn"}
       "Show SQL"])))

(defn save-button [{:keys [data-view]}]
  (let [{:data-view/keys [data-view-id]} data-view

        can-overwrite? @(re-posh/subscribe [:data-views.subs/can-modify data-view])
        editor-code    @(re-posh/subscribe [:data-views-page/prop :data-views-page/editor-code])

        on-save    #(dispatch [:data-views.api/update-data-view {:id        data-view-id
                                                                 :data-view (assoc data-view
                                                                                   :data-view/command editor-code)}])]
    [tooltip/tooltip {:content  [:div "You can’t make changes and save another user views"]
                      :disabled can-overwrite?}
     [:div
      [button {:size     :sm
               :variant  :secondary
               :disabled (or (not can-overwrite?)
                             (not (allowed? :data-views/write)))
               :on-click on-save}
       "Save"]]]))

(defn save-as-button []
  (let [on-save-as show-save-as-modal]
    [button {:size     :sm
             :variant  :secondary
             :disabled (not (allowed? :data-views/write))
             :on-click on-save-as}
     "Save as"]))

(defn share-button []
  [button {:size     :sm
           :variant  :secondary
           :on-click show-share-modal
           :data-cy  "data-view-header-share-btn"}
   "Share"])

(defn data-view-panel-header [{:keys [data-view data]}]
  (let [{:data-view/keys [name command]} data-view

        editor-code @(re-posh/subscribe [:data-views-page/prop :data-views-page/editor-code])
        edited-sql? (not= editor-code command)]
    [:div {:class "flex flex-col justify-between gap-2 p-3 border-b border-kleene-neutral-03 dark:border-kleene-dark-03"}
     [:div {:class "overflow-hidden"}
      [typography/h3 {:class "text-ellipsis whitespace-nowrap overflow-hidden"}
       name (when edited-sql? "*")]
      (when edited-sql?
        [:div {:class "flex gap-2 text-kleene-dark-04"}
         [:> Info {:size 16}]
         [typography/small {} "There are unsaved changes"]])]

     [:div {:class "flex gap-2 shrink-0 flex-wrap"}
      [preview-button {:data-view data-view}]
      [toggle-sql-button]
      [save-button {:data-view data-view}]
      [save-as-button {:data-view data-view}]
      [share-button]
      [download-button {:data-view data-view
                        :data      data}]
      [more-menu {:data-view data-view}]]]))

(defn data-view-panel [{:keys [data-view]}]
  (let [data @(re-posh/subscribe [:data-views-page/prop :data-views-page/data])]
    [:div {:class "flex flex-col h-full"}
     [data-view-panel-header {:data-view data-view :data data}]
     (if data
       [:f> preview]
       [data-view-preview-prompt {:data-view data-view}])]))

(defn data-view-splitter-inner [{:keys [data-view]}]
  (let [editor-height @(re-posh/subscribe [:data-views-page/prop :data-views-page/editor-height])
        show-editor   @(re-posh/subscribe [:data-views-page/prop :data-views-page/show-editor])
        editor-code   @(re-posh/subscribe [:data-views-page/prop :data-views-page/editor-code])


        resize-handler (react/useCallback
                        (fn [props]
                          (let [{:keys [height]} (js->clj props :keywordize-keys true)]
                            (dispatch [:data-views-all/update (->data-views-page {:editor-height height})])))
                        #js [])

        {:keys [ref]} (js->clj (useResizeDetector #js {:handleWidth  true
                                                       :handleHeight true
                                                       :refreshMode  "throttle"
                                                       :refreshRate  100
                                                       :onResize     resize-handler})
                               :keywordize-keys true)]
    [:> Allotment {:vertical true
                   :min-size 200
                   :default-sizes [20 80]}

     (when show-editor
       [:div {:class "h-full w-full grow relative overflow-hidden"
              :ref ref}

        [:f> monaco.editor/editor
         {:data-cy     "data-view-editor"
          :options     {:fontSize        14
                        :automaticLayout true
                        :contextmenu     true}
          :on-change   (fn [new-value]
                         (update-editor new-value))
          :controlled? true
          :value       editor-code}]])

     [data-view-panel {:data-view data-view}]]))

(defn data-view-splitter []
  (let [last-id (atom nil)]
    (reagent/create-class
     {:display-name "data-view-splitter"

      :component-did-mount
      (fn [this]
        (let [props (reagent/props this)
              {:keys [data-view]} props]
          (update-editor (:data-view/command data-view))
          (reset! last-id (:data-view/data-view-id data-view))))

      :component-did-update
      (fn [this]
        (let [props (reagent/props this)
              {:keys [data-view]} props
              id (:data-view/data-view-id data-view)]
          (when (not= @last-id id)
            (update-editor (:data-view/command data-view))
            (reset! last-id id))))

      :render
      (fn [this]
        (let [props (reagent/props this)
              {:keys [data-view]} props]
          [:f> data-view-splitter-inner {:data-view data-view}]))})))

(defn panel []
  (let [params    @(re-posh/subscribe [:app-route/prop :app-route/params])
        id        (:data-view-id params)
        data-view @(re-posh/subscribe [:data-views.subs/data-view id])]
    [:div {:class "h-full"}

     (if id
       (when data-view
         [data-view-splitter {:data-view data-view}])
       [select-prompt])

     [save-as-data-view-modal-render]
     [share-data-view-modal-render]
     [delete-data-view-modal-render]]))
